import Swatch from './swatch';

export default Swatch;
